import { Div, Link, Span } from "@tblabs/truffle";
import { ProductCategory } from "../../../Models/Product/ProductCategory";


export class CategoryBreadcrumbs extends Div
{
    constructor(category: ProductCategory)
    {
        super("category-breadcrumbs");

        this.Append(
            new Link("Oferta", "#kategorie-produktow").Class("product__breadcrumbs-link"),
            new Span().Html("&gt;").Class("product-breadcrumbs__separator"),
            new Link(category.Title.value, "#kategoria/" + category.Url.value).Class("product__breadcrumbs-link")
        );
    }
}
